




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class EstateStatus extends Vue {
    @Prop({ required: true }) status!: "available" | "prospect" | "option" | "bid" | "sold" | "rented" | "under_contract";

    @Prop({ required: true }) negotiation!: "let" | "sale";

    @Prop({ default: false }) isProject!: boolean;

    get computedStatus(): string {
        if (this.isProject) {
            return this.$t(`sweepbright.project`).toString();
        }

        let status: string = "";
        switch (this.status) {
            case "available":
            case "under_contract":
                status = this.$t(`sweepbright.${this.negotiation}`).toString();
                break;
            case "sold":
                status = this.$t(`sweepbright.sold`).toString();
                break;
            case "rented":
                status = this.$t(`sweepbright.rented`).toString();
                break;
            case "prospect":
                break;
            case "bid":
                status = this.$t(`sweepbright.option`).toString();
                break;
            case "option":
                status = this.$t(`sweepbright.option`).toString();
                break;
        }

        return status;
    }
}
